const Audition = ({ data }) => (
  <section className="audition-grid container pv6">
    <Info heading={data.heading} slides={data.slides} />
    <Reveal css={{ opacity: `0`, transform: `translateX(200px)` }}>
      <Img
        sizes={data.image.childImageSharp.sizes}
        alt={data.alt}
        critical={data.critical}
        className="ml-auto mr-auto w-75"
      />
    </Reveal>
  </section>
)

export default Audition

/*
 *
 * General
 * 
 */

import React from 'react'

import Img from '../components/Img'
import Reveal from '../components/Reveal'

/*
 *
 * Info
 * 
 */

import LearnMore from '../components/LearnMore'
import Slider from '../components/Slider'

const Info = ({ heading, slides }) => (
  <div className="audition-ga-info">
    <h2 className="subheading mb3">{heading}</h2>
    <Slider data={slides} />
    <LearnMore className="btn mb5" />
  </div>
)



// WEBPACK FOOTER //
// ./src/sections/Audition.js